import { dfpConst } from './const';
import { defineSlot, removeSlot, enableServices, displayId } from "../dfp"

const GPT_SCRIPT_SRC = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';

const runWhenGptReady = (callback) => {
  if (typeof window === 'undefined') return;

  window.googletag = window.googletag || { cmd: [] };
  window.googletag.cmd.push(callback);

  if (window.googletag.apiReady) return;

  const existingScript =
    document.querySelector(`script[src="${GPT_SCRIPT_SRC}"]`) ||
    document.getElementById('gpt-loader-script');

  if (existingScript) return;

  const script = document.createElement('script');
  script.id = 'gpt-loader-script';
  script.src = GPT_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
};

export const DefineSlotsHome = () => {
  if (typeof window !== 'undefined') {
    runWhenGptReady(() => {

      if(window?.innerWidth > 768){ // define slots for web
        removeSlot();
  
        defineSlot(`${dfpConst.Desk_HP_970x90.name}`, `${dfpConst.Desk_HP_970x90.id}`, dfpConst.Desk_HP_970x90.size,  { section: ['Homepage'], position: '1' })
        defineSlot(`${dfpConst.Desk_HP_728x90.name}`, `${dfpConst.Desk_HP_728x90.id}`, dfpConst.Desk_HP_728x90.size,  { section: ['Homepage'], position: '1' })
        defineSlot(`${dfpConst.Desk_HP_300x250.name}`, `${dfpConst.Desk_HP_300x250.id}`, dfpConst.Desk_HP_300x250.size, { section: ['Homepage'], position: '2' })
        defineSlot(`${dfpConst.Desk_HP_300x600.name}`, `${dfpConst.Desk_HP_300x600.id}`, dfpConst.Desk_HP_300x600.size, { section: ['Homepage'], position: '3' })
        defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['Homepage'], position: '7' })
        defineSlot(`${dfpConst.Desk_HP_Ad1_970x90.name}`, `${dfpConst.Desk_HP_Ad1_970x90.id}`, dfpConst.Desk_HP_Ad1_970x90.size,  { section: ['Homepage'], position: '8' })
        defineSlot(`${dfpConst.Desk_HP_Ad2_970x120.name}`, `${dfpConst.Desk_HP_Ad2_970x120.id}`, dfpConst.Desk_HP_Ad2_970x120.size,  { section: ['Homepage'], position: '9' })
        defineSlot(`${dfpConst.Desk_HP_Ad3_970x120.name}`, `${dfpConst.Desk_HP_Ad3_970x120.id}`, dfpConst.Desk_HP_Ad3_970x120.size,  { section: ['Homepage'], position: '12' })
        defineSlot(`${dfpConst.Desk_HP_3.name}`, `${dfpConst.Desk_HP_3.id}`, dfpConst.Desk_HP_3.size,  { section: ['Homepage'], position: '10' })
        defineSlot(`${dfpConst.Tab_Home_Banner2_744x98.name}`, `${dfpConst.Tab_Home_Banner2_744x98.id}`, dfpConst.Tab_Home_Banner2_744x98.size,  { section: ['Homepage'], position: '10' })
        defineSlot(`${dfpConst.Desk_HP_SideAd2_300x250.name}`, `${dfpConst.Desk_HP_SideAd2_300x250.id}`, dfpConst.Desk_HP_SideAd2_300x250.size,  { section: ['Homepage'], position: '11' })
        defineSlot(`${dfpConst.Tab_Home_Banner3_744x98.name}`, `${dfpConst.Tab_Home_Banner3_744x98.id}`, dfpConst.Tab_Home_Banner3_744x98.size,  { section: ['Homepage'], position: '10' })
        enableServices()
        
        displayId(dfpConst.Desk_HP_970x90.id)
        displayId(dfpConst.Desk_HP_728x90.id)
        displayId(dfpConst.Desk_HP_300x250.id)
        displayId(dfpConst.Desk_HP_300x600.id)
        displayId(dfpConst.Desk_Between_728x90.id)
        displayId(dfpConst.Desk_HP_Ad1_970x90.id)
        displayId(dfpConst.Desk_HP_Ad2_970x120.id)
        displayId(dfpConst.Desk_HP_Ad3_970x120.id)
        displayId(dfpConst.Desk_HP_3.id)
        displayId(dfpConst.Desk_HP_SideAd2_300x250.id)
        displayId(dfpConst.Tab_Home_Banner2_744x98.id)
        displayId(dfpConst.Tab_Home_Banner3_744x98.id)

      } else { // define slots for mobile
        removeSlot();

        defineSlot(`${dfpConst.Mobile_HP300X100.name}`, `${dfpConst.Mobile_HP300X100.id}`, dfpConst.Mobile_HP300X100.size, { section: ['Homepage'], position: '4' })
        defineSlot(`${dfpConst.Mobile_HP_300X600.name}`, `${dfpConst.Mobile_HP_300X600.id}`, dfpConst.Mobile_HP_300X600.size, { section: ['Homepage'], position: '5' })
        defineSlot(`${dfpConst.Mobile_HP_300X250.name}`, `${dfpConst.Mobile_HP_300X250.id}`, dfpConst.Mobile_HP_300X250.size, { section: ['Homepage'], position: '6' })
        defineSlot(`${dfpConst.Mob_Home_banner3_430x57.name}`, `${dfpConst.Mob_Home_banner3_430x57.id}`, dfpConst.Mob_Home_banner3_430x57.size,  { section: ['Homepage'], position: '11' })
        //defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['Homepage'], position: '6' })
        defineSlot(`${dfpConst.APP_Midddle_320x50.name}`, `${dfpConst.APP_Midddle_320x50.id}`, dfpConst.APP_Midddle_320x50.size, { section: ['Homepage'], position: '6' })
        defineSlot(`${dfpConst.APP_TOP_300x250.name}`, `${dfpConst.APP_TOP_300x250.id}`, dfpConst.APP_TOP_300x250.size, { section: ['Homepage'], position: '6' })
        defineSlot(`${dfpConst.Mob_Home_banner2_430x57.name}`, `${dfpConst.Mob_Home_banner2_430x57.id}`, dfpConst.Mob_Home_banner2_430x57.size, { section: ['Homepage'], position: '12' })
        enableServices()
  
        displayId(dfpConst.Mobile_HP300X100.id)
        displayId(dfpConst.Mobile_HP_300X600.id)
        displayId(dfpConst.Mobile_HP_300X250.id)
        //displayId(dfpConst.APP_Bottom_300x250.id)
        displayId(dfpConst.APP_Midddle_320x50.id)
        displayId(dfpConst.APP_TOP_300x250.id)
        displayId(dfpConst.Mob_Home_banner2_430x57.id)
        displayId(dfpConst.Mob_Home_banner3_430x57.id)


      }

        // removeSlot();
  
        // defineSlot(`${dfpConst.Desk_HP_970x90.name}`, `${dfpConst.Desk_HP_970x90.id}`, dfpConst.Desk_HP_970x90.size,  { section: ['Homepage'], position: '1' })

        // defineSlot(`${dfpConst.Desk_HP_728x90.name}`, `${dfpConst.Desk_HP_728x90.id}`, dfpConst.Desk_HP_728x90.size,  { section: ['Homepage'], position: '1' })
        // defineSlot(`${dfpConst.Desk_HP_300x250.name}`, `${dfpConst.Desk_HP_300x250.id}`, dfpConst.Desk_HP_300x250.size, { section: ['Homepage'], position: '2' })
        // defineSlot(`${dfpConst.Desk_HP_300x600.name}`, `${dfpConst.Desk_HP_300x600.id}`, dfpConst.Desk_HP_300x600.size, { section: ['Homepage'], position: '3' })
        // defineSlot(`${dfpConst.Mobile_HP300X100.name}`, `${dfpConst.Mobile_HP300X100.id}`, dfpConst.Mobile_HP300X100.size, { section: ['Homepage'], position: '4' })
        // defineSlot(`${dfpConst.Mobile_HP_300X600.name}`, `${dfpConst.Mobile_HP_300X600.id}`, dfpConst.Mobile_HP_300X600.size, { section: ['Homepage'], position: '5' })
        // defineSlot(`${dfpConst.Mobile_HP_300X250.name}`, `${dfpConst.Mobile_HP_300X250.id}`, dfpConst.Mobile_HP_300X250.size, { section: ['Homepage'], position: '6' })

        // defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['Homepage'], position: '6' })
        // defineSlot(`${dfpConst.APP_Midddle_320x50.name}`, `${dfpConst.APP_Midddle_320x50.id}`, dfpConst.APP_Midddle_320x50.size, { section: ['Homepage'], position: '6' })
        // defineSlot(`${dfpConst.APP_TOP_300x250.name}`, `${dfpConst.APP_TOP_300x250.id}`, dfpConst.APP_TOP_300x250.size, { section: ['Homepage'], position: '6' })

        // defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['Homepage'], position: '7' })
  
        // enableServices()
  
        // displayId(dfpConst.Desk_HP_970x90.id)

        // displayId(dfpConst.Desk_HP_728x90.id)
        // displayId(dfpConst.Desk_HP_300x250.id)
        // displayId(dfpConst.Desk_HP_300x600.id)
        // displayId(dfpConst.Mobile_HP300X100.id)
        // displayId(dfpConst.Mobile_HP_300X600.id)
        // displayId(dfpConst.Mobile_HP_300X250.id)
        // displayId(dfpConst.APP_Bottom_300x250.id)
        // displayId(dfpConst.APP_Midddle_320x50.id)
        // displayId(dfpConst.APP_TOP_300x250.id)

        // displayId(dfpConst.Desk_Between_728x90.id)
  
      })
    }

}

export const DefineSlotsInnerPage = () => {
  if (typeof window !== 'undefined') {
  runWhenGptReady(() => {

    if(window?.innerWidth > 768){ // define slots for web - inner pages
      removeSlot();

      defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['InnerPage'], position: '1' })
      defineSlot(`${dfpConst.Desk_Between_300x600.name}`, `${dfpConst.Desk_Between_300x600.id}`, dfpConst.Desk_Between_300x600.size, { section: ['InnerPage'], position: '2' })
      defineSlot(`${dfpConst.Desk_Between_300x250.name}`, `${dfpConst.Desk_Between_300x250.id}`, dfpConst.Desk_Between_300x250.size, { section: ['InnerPage'], position: '3' })
      defineSlot(`${dfpConst.Desk_UnderArticle_1280x168.name}`, `${dfpConst.Desk_UnderArticle_1280x168.id}`, dfpConst.Desk_UnderArticle_1280x168.size,  { section: ['InnerPage'], position: '7' })
      defineSlot(`${dfpConst.CNBC_Desk_Article_End.name}`, `${dfpConst.CNBC_Desk_Article_End.id}`, dfpConst.CNBC_Desk_Article_End.size,  { section: ['InnerPage'], position: '13' })
        
      enableServices()

      displayId(dfpConst.Desk_Between_728x90.id)
      displayId(dfpConst.Desk_Between_300x600.id)
      displayId(dfpConst.Desk_Between_300x250.id)
      displayId(dfpConst.Desk_UnderArticle_1280x168.id)
      displayId(dfpConst.CNBC_Desk_Article_End.id)

    } else { // define slots for mobile  - inner pages
      removeSlot();

      defineSlot(`${dfpConst.Mobile_Inner_Page300X600.name}`, `${dfpConst.Mobile_Inner_Page300X600.id}`, dfpConst.Mobile_Inner_Page300X600.size, { section: ['InnerPage'], position: '4' })
      defineSlot(`${dfpConst.Mobile_Inner_Page300X250.name}`, `${dfpConst.Mobile_Inner_Page300X250.id}`, dfpConst.Mobile_Inner_Page300X250.size, { section: ['InnerPage'], position: '5' })
      defineSlot(`${dfpConst.Mobile_Inner_Page300X100.name}`, `${dfpConst.Mobile_Inner_Page300X100.id}`, dfpConst.Mobile_Inner_Page300X100.size, { section: ['InnerPage'], position: '6' })
      defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['InnerPage'], position: '7' })
      defineSlot(`${dfpConst.CNBC_Mobile_Article_End.name}`, `${dfpConst.CNBC_Mobile_Article_End.id}`, dfpConst.CNBC_Mobile_Article_End.size, { section: ['InnerPage'], position: '14' })

      enableServices()

      displayId(dfpConst.Mobile_Inner_Page300X600.id)
      displayId(dfpConst.Mobile_Inner_Page300X250.id)
      displayId(dfpConst.Mobile_Inner_Page300X100.id)
      displayId(dfpConst.APP_Bottom_300x250.id)
      displayId(dfpConst.CNBC_Mobile_Article_End.id)

    }

      // removeSlot();

      // defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['InnerPage'], position: '1' })
      // defineSlot(`${dfpConst.Desk_Between_300x600.name}`, `${dfpConst.Desk_Between_300x600.id}`, dfpConst.Desk_Between_300x600.size, { section: ['InnerPage'], position: '2' })
      // defineSlot(`${dfpConst.Desk_Between_300x250.name}`, `${dfpConst.Desk_Between_300x250.id}`, dfpConst.Desk_Between_300x250.size, { section: ['InnerPage'], position: '3' })
      // defineSlot(`${dfpConst.Mobile_Inner_Page300X600.name}`, `${dfpConst.Mobile_Inner_Page300X600.id}`, dfpConst.Mobile_Inner_Page300X600.size, { section: ['InnerPage'], position: '4' })
      // defineSlot(`${dfpConst.Mobile_Inner_Page300X250.name}`, `${dfpConst.Mobile_Inner_Page300X250.id}`, dfpConst.Mobile_Inner_Page300X250.size, { section: ['InnerPage'], position: '5' })
      // defineSlot(`${dfpConst.Mobile_Inner_Page300X100.name}`, `${dfpConst.Mobile_Inner_Page300X100.id}`, dfpConst.Mobile_Inner_Page300X100.size, { section: ['InnerPage'], position: '6' })

      // defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['InnerPage'], position: '7' })


      // enableServices()

      // displayId(dfpConst.Desk_Between_728x90.id)
      // displayId(dfpConst.Desk_Between_300x600.id)
      // displayId(dfpConst.Desk_Between_300x250.id)
      // displayId(dfpConst.Mobile_Inner_Page300X600.id)
      // displayId(dfpConst.Mobile_Inner_Page300X250.id)
      // displayId(dfpConst.Mobile_Inner_Page300X100.id)

      // displayId(dfpConst.APP_Bottom_300x250.id)

    })
  }
}


export const DefineSlotsLivePage = () => {
  if (typeof window !== 'undefined') {
  runWhenGptReady(() => {

    if(window?.innerWidth > 768){ // define slots for web - inner pages
      removeSlot();

      defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['liveTvPage'], position: '1' })
      
      enableServices()
      displayId(dfpConst.Desk_Between_728x90.id)

    } else {
      removeSlot();

      defineSlot(`${dfpConst.Mobile_Inner_Page300X100.name}`, `${dfpConst.Mobile_Inner_Page300X100.id}`, dfpConst.Mobile_Inner_Page300X100.size, { section: ['InnerPage'], position: '6' })
      //defineSlot(`${dfpConst.APP_Bottom_300x250.name}`, `${dfpConst.APP_Bottom_300x250.id}`, dfpConst.APP_Bottom_300x250.size, { section: ['InnerPage'], position: '7' })
      defineSlot(`${dfpConst.Mobile_LiveStream300x250.name}`, `${dfpConst.Mobile_LiveStream300x250.id}`, dfpConst.Desk_HP_728x90.size, { section: ['liveTvPage'], position: '5' })

      enableServices()

      displayId(dfpConst.Mobile_Inner_Page300X100.id)
      //displayId(dfpConst.APP_Bottom_300x250.id)
      displayId(dfpConst.Mobile_LiveStream300x250.id)

    }

      // removeSlot();

      // defineSlot(`${dfpConst.Desk_Between_728x90.name}`, `${dfpConst.Desk_Between_728x90.id}`, dfpConst.Desk_Between_728x90.size,  { section: ['liveTvPage'], position: '1' })
      // defineSlot(`${dfpConst.Desk_Between_300x600.name}`, `${dfpConst.Desk_Between_300x600.id}`, dfpConst.Desk_Between_300x600.size, { section: ['liveTvPage'], position: '2' })
      // defineSlot(`${dfpConst.Desk_Between_300x250.name}`, `${dfpConst.Desk_Between_300x250.id}`, dfpConst.Desk_Between_300x250.size, { section: ['liveTvPage'], position: '3' })
      // defineSlot(`${dfpConst.Desk_LiveStream_300x250.name}`, `${dfpConst.Desk_LiveStream_300x250.id}`, dfpConst.Desk_LiveStream_300x250.size, { section: ['liveTvPage'], position: '4' })
      // defineSlot(`${dfpConst.Mobile_LiveStream300x250.name}`, `${dfpConst.Mobile_LiveStream300x250.id}`, dfpConst.Desk_HP_728x90.size, { section: ['liveTvPage'], position: '5' })
      // defineSlot(`${dfpConst.Mobile_Inner_Page300X100.name}`, `${dfpConst.Mobile_Inner_Page300X100.id}`, dfpConst.Mobile_Inner_Page300X100.size, { section: ['InnerPage'], position: '6' })
      
      // enableServices()

      // displayId(dfpConst.Desk_Between_728x90.id)
      // displayId(dfpConst.Desk_Between_300x600.id)
      // displayId(dfpConst.Desk_Between_300x250.id)
      // displayId(dfpConst.Desk_LiveStream_300x250.id)
      // displayId(dfpConst.Mobile_LiveStream300x250.id)
      // displayId(dfpConst.Mobile_Inner_Page300X100.id)

    })
  }

}

